var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-widget",on:{"click":_vm.onClick}},[_c('div',{staticClass:"task-image",attrs:{"title":_vm.title}},[_c('img',{style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
    }),attrs:{"src":require("@/assets/admin-icon/menu/tasks.svg")}})]),_c('div',{staticClass:"task-widget-content"},[(_vm.title)?_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm._f("validate")(_vm.$validateString(_vm.title)))+" ")]):_vm._e(),(_vm.subtitle)?_c('span',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm._f("validate")(_vm.subtitle))+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }